import { render, staticRenderFns } from "./TheAuthenticationPage.vue?vue&type=template&id=2c51b658"
import script from "./TheAuthenticationPage.vue?vue&type=script&lang=js"
export * from "./TheAuthenticationPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports